module.exports = __webpack_public_path__ + "img/kmz.62364efa.png";